export default __webpack_public_path__ + "static/media/MVRDV-section-01.74558425.jpg";